import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

interface Params {
  pathname?: string;
  params?: Record<string, string>;
  /** 기존 query params에 추가할지, 또는 params로 교체할지 여부 */
  replaceParams?: boolean;
}

/**
 * pathname과 query params 이용해 표준 URL로 파싱
 * @param param0
 */
export default function useQueryParamURL({
  pathname,
  params = {},
  replaceParams
}: Params) {
  const location = useLocation();
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    const paramsObj = new URLSearchParams(params);
    const _pathname = pathname ?? location.pathname;
    const _params = `${paramsObj.toString()}${
      replaceParams ? '' : `&${location.search}`
    }`;
    const _url = `${_pathname}?${_params}`;

    setUrl(_url);
  }, [location, pathname, params]);

  return url;
}
